export const formatAudioSource = (audioUrl: string): string => {
  try {
    return new URL(audioUrl).host || audioUrl;
  } catch {
    return audioUrl;
  }
};
